import type { BlogFrontmatter } from "./types";

/**
 * Content-getriebene Blog-Registry.
 *
 * Neue Artikel entstehen allein durch das Anlegen einer Datei
 * `src/content/blog/<slug>.tsx`, die `frontmatter` (BlogFrontmatter) und eine
 * Default-Component (den Body) exportiert. Vites `import.meta.glob` sammelt sie
 * automatisch ein – Index, Einzelseite, Schema, Sitemap und Prerender leiten
 * sich daraus ab.
 *
 * `generated/` (gitignored) enthält die per `npm run sync:blog` aus
 * BabyLoveGrowth erzeugten Artikel.
 */

// Nur das Frontmatter (eager) – der Body wird hier ge-tree-shaked.
const frontmatterModules = import.meta.glob<BlogFrontmatter>(["./*.tsx", "./generated/*.tsx"], {
  eager: true,
  import: "frontmatter",
});

const allFrontmatter: BlogFrontmatter[] = Object.values(frontmatterModules).sort(
  (a, b) => (a.datePublished < b.datePublished ? 1 : -1),
);

/** Alle Artikel (inkl. Drafts), neueste zuerst. */
export function getAllPosts(): BlogFrontmatter[] {
  return allFrontmatter;
}

/** Nur veröffentlichte Artikel (kein draft), neueste zuerst. */
export function getPublishedPosts(): BlogFrontmatter[] {
  return allFrontmatter.filter((fm) => !fm.draft);
}

/** Frontmatter eines Artikels per Slug (auch Drafts, für Vorschau). */
export function getPostBySlug(slug: string): BlogFrontmatter | undefined {
  return allFrontmatter.find((fm) => fm.slug === slug);
}
